export const clientId=501109
export const SCHOOL_Id = "X-SCHOOL-ID";
export const USER_INFO = "USER_INFO";




// WEBPACK FOOTER //
// ./src/js/utils/constant.js